import { FC, useRef } from 'react';
import { OverlayPanel } from 'primereact/overlaypanel';
import { CalendarDays } from 'lucide-react';
import ExitSlipCalendar from './ExitSlipCalendar';
import { ExitSlipPastTag, shortDay } from '../../businessLogicService/exitSlipSnapshotHelper';

interface Props {
  value: Date | null;
  //days that already hold a ticket for this class — greyed and tagged, never selectable
  blocked: ExitSlipPastTag[];
  pastTags: ExitSlipPastTag[];
  readOnly?: boolean;
  placeholder?: string;
  onChange: (day: Date) => void;
  //days that carry a lesson but stay pickable — the dashboard picker tags every ticket this way
  schedule?: ExitSlipPastTag[];
  canceled?: Date[];
  selectablePast?: boolean;
  maxDate?: Date | null;
  className?: string;
}

//160px + nowrap: at 140px "Select a date" wraps to two lines
const fieldClass =
  'tw-flex tw-h-11 tw-w-40 tw-shrink-0 tw-items-center tw-justify-between tw-gap-3 tw-overflow-hidden tw-whitespace-nowrap tw-rounded-xl tw-border-2 tw-border-solid tw-border-neutral-100 tw-bg-white tw-px-3 tw-font-atkinson tw-text-base tw-leading-6 tw-text-neutral-700';

const ExitSlipDateField: FC<Props> = ({
  value,
  blocked,
  pastTags,
  readOnly = false,
  placeholder = 'Select a date',
  onChange,
  schedule = [],
  canceled = [],
  selectablePast = false,
  maxDate,
  className = '',
}) => {
  const overlay = useRef<OverlayPanel>(null);

  const label = value ? shortDay(value) : placeholder;

  if (readOnly) {
    return (
      <div className={`${fieldClass} ${className}`}>
        <span className="tw-truncate">{label}</span>
        <CalendarDays size={18} strokeWidth={2} className="tw-shrink-0 tw-text-neutral-700" />
      </div>
    );
  }

  return (
    <>
      <button
        type="button"
        onClick={event => overlay.current?.toggle(event)}
        className={`${fieldClass} ${className} tw-cursor-pointer`}
      >
        <span className="tw-truncate">{label}</span>
        <CalendarDays size={18} strokeWidth={2} className="tw-shrink-0 tw-text-neutral-700" />
      </button>
      <OverlayPanel ref={overlay} pt={{ content: { className: '!tw-p-0' }, root: { className: '!tw-border-none' } }}>
        <ExitSlipCalendar
          schedule={schedule}
          pastTags={pastTags}
          blocked={blocked}
          canceled={canceled}
          selectablePast={selectablePast}
          maxDate={maxDate}
          target={value}
          onPick={day => {
            onChange(day);
            overlay.current?.hide();
          }}
        />
      </OverlayPanel>
    </>
  );
};

export default ExitSlipDateField;
